import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";

const SimpleInputForm = ({
  placeholder,
  onChange,
  label,
  name,
  value,
  type = "text",
  hasPattern = false,
  pattern = "",
  hasIcon = false,
  icon,
  iconPosition = "start",
  required = false,
}) => {
  return (
    <FormControl variant="outlined" className="w-full" onChange={e => onChange(e)}>
      <InputLabel htmlFor={label}>{label}</InputLabel>
      <OutlinedInput
        value={value}
        type={type}
        label={label}
        placeholder={placeholder}
        name={name}
        autoComplete={"off"}
        required={required}
        startAdornment={
          hasIcon && (
            <InputAdornment position={iconPosition} sx={{ margin: 0 }}>
              {icon}
            </InputAdornment>
          )
        }
        inputProps={
          hasPattern
            ? { style: { fontSize: "14px" }, pattern: pattern }
            : { style: { fontSize: "14px" } }
        }
        sx={{
          ".MuiOutlinedInput-root:hover ": {},
          ".MuiOutlinedInput-notchedOutline:hover": {},
          ".MuiInputLabel-root": {
            fontSize: "14px !important",
          },
        }}
      />
    </FormControl>
  );
};
export default SimpleInputForm;
